// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
// import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import * as service from '../../../services/service';

function ItemReceipt() {
    const [receiptNo, setReceiptNo] = useState([]);
    const [receiptDate, setReceiptDate] = useState([]);
    const [receivedQuantity, setReceivedQuantity] = useState([]);
    const [dismantledQuantity, setDismantledQuantity] = useState([]);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [receipts, setReceipts] = useState([]);
    // const [vendorId, setVendorId] = useState('');
    // const [VendorData, setVendorData] = useState([]);
    const [errors, setErrors] = useState({});
    const [dataError, setDataError] = useState(null);
    const [loading, setLoading] = useState(false);

    // const navigate = useNavigate();

    // const getVendors = () => {
    //     fetch(
    //         service.VENDOR_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.vendorId, label: item.vendorName }));
    //             setVendorData(data2);
    //         });
    // };

    const validateSearch = () => {
        let isValid = true;
        const errs = {};
        if (!search) {
            isValid = false;
            errs[".search"] = "Please enter demand number";
            setErrors(errs);
        }
        return isValid;
    }
    const validateSubmit = () => {
        let isValid = true;
        const errs = {};
        if (!receiptNo[0]) {
            isValid = false;
            errs[".receiptNo"] = "Please enter receipt no.";
            setErrors(errs);
        }
        if (!receiptDate[0]) {
            isValid = false;
            errs[".receiptDate"] = "Please enter receipt date.";
            setErrors(errs);
        }
        if (!receivedQuantity[0]) {
            isValid = false;
            errs[".receivedQuantity"] = "Please enter received quantity.";
            setErrors(errs);
        }
        return isValid;
    }

    const getDetails = () => {
        setLoading(true);
        if (validateSearch()) {
            fetch(
                service.ITEM_RECEIPT_BY_SEARCH_URL,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DemandNo: search,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result[0].messageType === "Failed") {
                        setDataError(result[0].message);
                        setData([]);
                    }
                    else {
                        setData(result);
                        // result.forEach((element, index) => {
                        //     receiptNo[index] = element.receiptNo;
                        //     setReceiptNo([...receiptNo]);
                        //     receiptDate[index] = element.receiptDate;
                        //     setReceiptDate([...receiptDate]);
                        //     receivedQuantity[index] = element.receivedQuantity;
                        //     setReceivedQuantity([...receivedQuantity]);
                        //     dismantledQuantity[index] = element.dismantledQuantity;
                        //     setDismantledQuantity([...dismantledQuantity]);
                        // });
                        setDataError('');
                    }
                })
                .catch(err => {
                    if (err) {
                        setDataError(err);
                    };
                });
        }
        setLoading(false);
    };

    const getReceipts = () => {
        setLoading(true);
        if (validateSearch()) {
            fetch(
                service.GET_ITEM_RECEIPT_DETAILS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DemandNo: search,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                    })
                })
                .then(res => res.json())
                .then(result => {                    
                    if (result[0].message.messageType === "Failed") {
                        setDataError(result[0].message.message);
                        setReceipts([]);
                    }
                    else {
                        setReceipts(result);
                        setDataError('');
                    }
                })
                .catch(err => {
                    if (err) {
                        setDataError(err);
                    };
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        setLoading(false);
    }, []);

    const searchHandler = () => {
        getDetails();
        getReceipts();
    }
    const receiptNoChangeHandler = (event, index) => {
        let updatedObject = receiptNo[index];
        updatedObject = event.target.value;
        receiptNo[index] = updatedObject;
        setReceiptNo([...receiptNo]);
    };

    const receiptDateChangeHandler = (event, index) => {
        let updatedObject = receiptDate[index];
        updatedObject = event;
        receiptDate[index] = updatedObject;
        setReceiptDate([...receiptDate]);
    };

    const receivedQuantityChangeHandler = (event, index) => {
        let updatedObject = receivedQuantity[index];
        updatedObject = event.target.value;
        receivedQuantity[index] = updatedObject;
        setReceivedQuantity([...receivedQuantity]);
    };

    const dimantaledQuantityChangeHandler = (event, index) => {
        let updatedObject = dismantledQuantity[index];
        updatedObject = event.target.value;
        dismantledQuantity[index] = updatedObject;
        setDismantledQuantity([...dismantledQuantity]);
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validateSubmit()) {
            data.forEach((element, index) => {
                if (receiptNo[index] && receiptDate[index] &&
                    receivedQuantity[index] > 0) {
                    fetch(
                        service.ADD_ITEM_RECEIPT,
                        {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                ReceiptId: element.receiptId,
                                ReceiptDate: moment(receiptDate[index]).format("MM/DD/YYYY"),
                                ReceiptNo: receiptNo[index],
                                ItemCategoryId: element.itemCategoryId,
                                ItemId: element.itemId,
                                ReceivedQuantity: receivedQuantity[index],
                                DismantledQuantity: dismantledQuantity[index],
                                Unit: element.unit,
                                DemandId: element.demandId,
                                DetailId: element.detailId,
                                ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                                AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                                UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                            })
                        })
                        .then(res => res.json())
                        .then(result => {
                            if (result.messageType === 'Failed') {
                                // eslint-disable-next-line
                                alert(result.message);
                            }
                            else {
                                errs[".invalid"] = result.message;
                                setErrors(errs);
                            }
                        });
                }
            });
            // eslint-disable-next-line
            alert("Data Added Successfully.");
            window.location.reload();
        }
        setLoading(false);
    }

    const handleDelete = (rectId) => {
        setLoading(true);
        fetch(
            service.DELETE_ITEM_RECEIPT,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ReceiptId: rectId
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.messageType === "Failed") {
                    setDataError(result.message);
                }
                else {
                    // eslint-disable-next-line                              
                    alert('Data Deleted Sucessfully');
                }
            })
            .catch(err => {
                if (err) {
                    setDataError(err);
                };
            });
        window.location.reload();
        setLoading(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Item Receipt Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <MDBox mx={2}
                                mt={-3}
                                py={3}
                                px={2}>
                                <Stack direction="row" spacing={5}>
                                    <MDInput label="Demand No." value={search}
                                        name="search"
                                        onChange={ev => setSearch(ev.target.value)}
                                        id="search"
                                        required
                                    />
                                    {/* <div style={{ width: '20%', fontSize: '14px' }}>
                                        <Dropdown menuClassName='myMenuClassName' id="vendor"
                                            name="vendor"
                                            options={VendorData}
                                            value={vendorId}
                                            onChange={vendorChangeHandler}
                                            label="Vendor"
                                            placeholder="Select Vendor"
                                        />
                                    </div> */}
                                    <MDButton color="info" onClick={searchHandler} endIcon={<SearchIcon />}>
                                        Search
                                    </MDButton>
                                </Stack>
                                <div style={{ fontSize: '12px', color: 'green' }}>Search by Demand No</div>
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".search"]}</div>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontSize: '12px', color: 'red' }}>{dataError}</div>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Demand No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Demand Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Unit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Ordered Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Balance Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Received Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Dismantled Quantity</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.detailId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.demandNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.demandDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.item}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.unit}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.orderedQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.balancedQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>
                                                            <MDInput label="Receipt No" fullWidth value={receiptNo[index] || ''}
                                                                name="receiptno"
                                                                onChange={ev => receiptNoChangeHandler(ev, index)}
                                                                id="receiptno"
                                                            />
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".receiptNo"]}</div>
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>
                                                            <div style={{ fontSize: '12px' }}>
                                                                Receipt Date
                                                                <DatePicker
                                                                    id="receiptDate"
                                                                    selected={moment(receiptDate[index]).toDate()}
                                                                    onChange={ev => receiptDateChangeHandler(ev, index)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".receiptDate"]}</div>
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>
                                                            <MDInput label="Received Quantity" fullWidth value={receivedQuantity[index] || ''}
                                                                name="receivedQuantity"
                                                                onChange={ev => receivedQuantityChangeHandler(ev, index)}
                                                                id="receivedQuantity"
                                                            />
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".receivedQuantity"]}</div>
                                                        </TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>
                                                            <MDInput label="Dismantled Quantity" fullWidth value={dismantledQuantity[index] || ''}
                                                                name="dismantledQuantity"
                                                                onChange={ev => dimantaledQuantityChangeHandler(ev, index)}
                                                                id="dismantledQuantity"
                                                            />
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".dismantledQuantity"]}</div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <MDButton color="info" onClick={submitHandler}>
                                            SAVE
                                        </MDButton>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                        Receipts
                                    </div>
                                </MDBox>
                                <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt No</TableCell>                                                
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Receipt Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Unit</TableCell>                                                
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Received Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Dismantled Quantity</TableCell>                                                
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Delete</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {receipts.map((row) => (
                                                    <TableRow
                                                        key={row.receiptId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.receiptNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.receiptDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.item}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.unit}</TableCell>                                                        
                                                        <TableCell style={{ fontSize: '14px' }}>{row.receivedQuantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.dismantledQuantity}</TableCell>                                                                                                                
                                                        <TableCell><MDButton onClick={() => handleDelete(row.receiptId)}>Delete</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default ItemReceipt;